import { axiosFactory } from '../../../client';
import { ValidateAccessLinkRequest, ValidateAccessLinkResponse } from '../model';
import * as ROUTES from './routes';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/candidate/api`;
const timeout = 5000;

export const candidateClient = axiosFactory(baseURL, timeout);

export const postValidateAccessLink = async (
  csrfToken: string,
  request: ValidateAccessLinkRequest
) =>
  candidateClient.post<ValidateAccessLinkResponse>(
    csrfToken,
    `${ROUTES.POST_VALIDATE_ACCESS_LINK}`,
    request
  );
